import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["srcset"]
const _hoisted_2 = ["srcset"]
const _hoisted_3 = ["srcset", "alt", "src", "loading", "width", "height", "sizes"]

import {
    type PropType,
    computed,
    onMounted,
    getCurrentInstance,
    ref,
} from "vue";
import { type IProductPictureInfo } from "../../list-item";
import { spacerUrl } from "../../../../shared/empty-pixel";
import { getWindowInnerWidth } from "../../../../../../utilities/browser-size";
import fastdom from "fastdom";


export default /*@__PURE__*/_defineComponent({
  __name: 'product-image',
  props: {
    item: {
        type: Object as PropType<
            IProductPictureInfo & {
                pictureAltText?: string;
                productName?: string;
                name?: string;
            }
        >,
    },
    fixedWidth: {
        type: Number,
    },
    fillWidth: Boolean,
    fallbackWidth: [Number, String],
    fallbackHeight: [Number, String],
    scaleOfScreen: {
        type: Number,
        default: 1,
    },
    lazy: Boolean,
    providedImageWidth: Number,
},
  emits: ["gotImageWidth"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const width = ref(-1);

const instance = getCurrentInstance();

onMounted(() => {
    if (instance == null) throw new Error("missing instance");

    if (props.providedImageWidth != null) {
        width.value = props.providedImageWidth;
    } else {
        fastdom.measure(() => {
            const rect = instance.proxy?.$el.getBoundingClientRect();
            width.value = rect.width;
            emit("gotImageWidth", rect.width);
        });
    }
});

const innerWidth = getWindowInnerWidth();

const actualScale = computed(() => {
    if (width.value === -1) return props.scaleOfScreen;
    return width.value / innerWidth.value;
});

const pictureUrlAsWebp = computed(() => {
    if (props.item == null) {
        return undefined;
    }
    return patchUrl(props.item.pictureUrlAsWebp ?? "", props.fixedWidth);
});

const pictureSrcSetAsWebp = computed(() => {
    return props.item?.pictureSrcSetAsWebp;
});
const pictureSrcSet = computed(() => {
    return props.item?.pictureSrcSet;
});

const fallbackWidthNumber = computed(() =>
    typeof props.fallbackWidth === "string"
        ? parseInt(props.fallbackWidth)
        : props.fallbackWidth
);
const fallbackHeightNumber = computed(() =>
    typeof props.fallbackHeight === "string"
        ? parseInt(props.fallbackHeight)
        : props.fallbackHeight
);

const pictureUrl = computed(() => {
    if (props.item == null) {
        return spacerUrl;
    }

    if (props.item.pictureUrl == null) {
        return spacerUrl;
    }

    return patchUrl(props.item.pictureUrl, props.fixedWidth);
});

const sizesSpec = computed(() => {
    if (actualScale.value != null) {
        return `${actualScale.value * 100}vw`;
    }
    return undefined;
});
const pictureWidth = computed(() => {
    if (props.fixedWidth != null) {
        return props.fixedWidth;
    }
    if (props.item == null) {
        return fallbackWidthNumber.value;
    }
    return props.item.pictureWidth ?? undefined;
});
const pictureHeight = computed(() => {
    if (props.item == null) {
        return fallbackHeightNumber.value;
    }
    if (props.fixedWidth != null) {
        const ratio =
            (props.item.pictureWidth ?? 1) / (props.item.pictureHeight ?? 1);
        return props.fixedWidth / ratio;
    }
    return props.item.pictureHeight ?? undefined;
});

function patchUrl(url: string, fixedWidth: number | undefined) {
    if (fixedWidth != null) {
        const urlObject = new URL(url);
        urlObject.searchParams.set("width", fixedWidth.toString());
        url = urlObject.toString();
    }
    return url;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("picture", null, [
    (pictureSrcSetAsWebp.value != null && pictureSrcSetAsWebp.value != '')
      ? (_openBlock(), _createElementBlock("source", {
          key: 0,
          srcset: pictureSrcSetAsWebp.value,
          type: "image/webp"
        }, null, 8 /* PROPS */, _hoisted_1))
      : (pictureUrlAsWebp.value != null && pictureUrlAsWebp.value != '')
        ? (_openBlock(), _createElementBlock("source", {
            key: 1,
            srcset: pictureUrlAsWebp.value,
            type: "image/webp"
          }, null, 8 /* PROPS */, _hoisted_2))
        : _createCommentVNode("v-if", true),
    _createElementVNode("img", {
      class: _normalizeClass({ 'fill-width': __props.fillWidth }),
      srcset: pictureSrcSet.value ?? undefined,
      alt: 
                __props.item != null
                    ? __props.item.pictureAltText ??
                      __props.item.productName ??
                      __props.item.productName
                    : undefined
            ,
      src: pictureUrl.value,
      loading: __props.lazy ? 'lazy' : undefined,
      width: pictureWidth.value,
      height: pictureHeight.value,
      sizes: sizesSpec.value
    }, null, 10 /* CLASS, PROPS */, _hoisted_3)
  ]))
}
}

})